// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3i0MV","content":"styles_content__VXfod","selectAll":"styles_selectAll__yLZ2J"};